import { IInitialFormData, IEditCustomerContext } from './editCustomerContext';

export enum EditCustomerActionTypes {
	REFETCH_DATA = 'REFETCH_DATA',
	SET_INITIAL_FORM_DATA = 'SET_INITIAL_FORM_DATA',
	SET_ALL_DATA = 'SET_ALL_DATA',
	CHANGE_VISIBLE_FORM = 'CHANGE_VISIBLE_FORM',
	SET_FILE = 'SET_FILE',
	DELETE_PHOTO = 'DELETE_PHOTO',
	CHANGE_NAME = 'CHANGE_NAME',
	CHANGE_EMAIL = 'CHANGE_EMAIL',
	CHANGE_EMAIL_BODY_TEMPLATE = 'CHANGE_EMAIL_BODY_TEMPLATE',
	SET_CLIENT_TYPE = 'SET_CLIENT_TYPE',
	CHANGE_BILL_TEMPLATE_FILE_DATA = 'CHANGE_BILL_TEMPLATE_FILE_DATA',
	CHANGE_BILL_ADVERTISING_IMAGE_DATA = 'CHANGE_BILL_ADVERTISING_IMAGE_DATA',
	CHANGE_BILL_ADVERTISING_LINK = 'CHANGE_BILL_ADVERTISING_LINK',
	DELETE_BILL_ADVERTISING_IMAGE = 'DELETE_BILL_ADVERTISING_IMAGE',
	CHANGE_PRICE_TYPE = 'CHANGE_PRICE_TYPE',
	SET_TIPS_0 = 'SET_TIPS_0',
	SET_TIPS_1 = 'SET_TIPS_1',
	SET_TIPS_2 = 'SET_TIPS_2',
	SET_TIPS_3 = 'SET_TIPS_3',
	SET_DEFAULT_TIPS = 'SET_DEFAULT_TIPS',
	TOGGLE_SHOW_LOYALTY_PROGRAM_BUTTONS = 'TOGGLE_SHOW_LOYALTY_PROGRAM_BUTTONS',
	CHANGE_BASE_MCC = 'CHANGE_BASE_MCC',
	CHANGE_MCC_CARD = 'CHANGE_MCC_CARD',
	CHANGE_MAIN_MCC_CARD_BRAND = 'CHANGE_MAIN_MCC_CARD_BRAND',
	CHANGE_MAIN_MCC_CARD_MCC = 'CHANGE_MAIN_MCC_CARD_MCC',
	SET_VIVA_WALLET_CREDENTIALS_ID = 'setVivaWalletCredentialsId',
	SET_ADS = 'SET_ADS',
	CHANGE_MENU_VERSION = 'SET_MENU_VERSION',
	CHANGE_CONTENT_VERSION = 'SET_CONTENT_VERSION',
	SET_MIXPANEL_TOKEN = 'SET_MIXPANEL_TOKEN',
	SET_STOP_LIST_SYNC_INTERVAL_MINUTES = 'SET_STOP_LIST_SYNC_INTERVAL_MINUTES',
	SET_FETCHED_LANGUAGES = 'SET_FETCHED_LANGUAGES',
	SET_ID_CUSTOMER_DEFAULT_LANGUAGE = 'SET_ID_CUSTOMER_DEFAULT_LANGUAGE',
	SET_IDs_CUSTOMER_LANGUAGES = 'SET_IDs_CUSTOMER_LANGUAGES',
	CHANGE_TAGS = 'CHANGE_TAGS',
	TOGGLE_ACTIVATE_BPA = 'TOGGLE_ACTIVATE_BPA',
	SET_DATA_FOR_SUBMIT = 'SET_DATA_FOR_SUBMIT',
	CHANGE_TYPE_OF_MODAL_WINDOW = 'CHANGE_TYPE_OF_MODAL_WINDOW',
	RESET_FIELDS = 'RESET_FIELDS',
}

interface IRefetchData {
	type: EditCustomerActionTypes.REFETCH_DATA;
	payload: {
		needRefetchData: IEditCustomerContext['needRefetchData'];
	};
}

interface ISetInitialFormData {
	type: EditCustomerActionTypes.SET_INITIAL_FORM_DATA;
	payload: {
		initialFormData: IInitialFormData;
	};
}

interface ISetAllData {
	type: EditCustomerActionTypes.SET_ALL_DATA;
	payload: {
		filePath: IEditCustomerContext['filePath'];
		customerId: IEditCustomerContext['customerId'];
		name: IEditCustomerContext['name'];
		email: IEditCustomerContext['email'];
		emailBodyTemplate: IEditCustomerContext['emailBodyTemplate'];
		clientType: IEditCustomerContext['clientType'];
		billTemplateFileData: IEditCustomerContext['billTemplateFileData'];
		billTemplateFilePath: IEditCustomerContext['billTemplateFilePath'];
		billAdvertisingImageData: IEditCustomerContext['billAdvertisingImageData'];
		billAdvertisingImage: IEditCustomerContext['billAdvertisingImage'];
		billAdvertisingLink: IEditCustomerContext['billAdvertisingLink'];
		priceType: IEditCustomerContext['priceType'];
		tips0: IEditCustomerContext['tips0'];
		tips1: IEditCustomerContext['tips1'];
		tips2: IEditCustomerContext['tips2'];
		tips3: IEditCustomerContext['tips3'];
		defaultTips: IEditCustomerContext['defaultTips'];
		isShowLoyaltyProgramButtons: IEditCustomerContext['isShowLoyaltyProgramButtons'];
		baseMcc: IEditCustomerContext['baseMcc'];
		mainMccCardBrand: IEditCustomerContext['mainMccCardBrand'];
		mainMccCardMcc: IEditCustomerContext['mainMccCardMcc'];
		mccCards: IEditCustomerContext['mccCards'];
		vivaWalletCredentialsId: IEditCustomerContext['vivaWalletCredentialsId'];
		ads: IEditCustomerContext['ads'];
		menuVersion: IEditCustomerContext['menuVersion'];
		contentVersion: IEditCustomerContext['contentVersion'];
		mixpanelToken: IEditCustomerContext['mixpanelToken'];
		stopListSyncIntervalMinutes: IEditCustomerContext['stopListSyncIntervalMinutes'];
		IDSelectedCustomerDefaultLanguage: IEditCustomerContext['IDSelectedCustomerDefaultLanguage'];
		IDsSelectedCustomerLanguages: IEditCustomerContext['IDsSelectedCustomerLanguages'];
		customerLanguages: IEditCustomerContext['customerLanguages'];
		tags: IEditCustomerContext['tags'];
		isActiveBpa: IEditCustomerContext['isActiveBpa'];
	};
}

interface IChangeVisibleForm {
	type: EditCustomerActionTypes.CHANGE_VISIBLE_FORM;
	payload: {
		visibleForm: IEditCustomerContext['visibleForm'];
	};
}

interface ISetFile {
	type: EditCustomerActionTypes.SET_FILE;
	payload: {
		fileId: IEditCustomerContext['fileId'];
		sourceUrlLocally: IEditCustomerContext['sourceUrlLocally'];
	};
}

interface IDeletePhoto {
	type: EditCustomerActionTypes.DELETE_PHOTO;
}

interface IChangeName {
	type: EditCustomerActionTypes.CHANGE_NAME;
	payload: {
		name: IEditCustomerContext['name'];
	};
}

interface IChangeEmail {
	type: EditCustomerActionTypes.CHANGE_EMAIL;
	payload: {
		email: IEditCustomerContext['email'];
	};
}

interface IChangeEmailBodyTemplate {
	type: EditCustomerActionTypes.CHANGE_EMAIL_BODY_TEMPLATE;
	payload: {
		emailBodyTemplate: IEditCustomerContext['emailBodyTemplate'];
	};
}

interface ISetClientType {
	type: EditCustomerActionTypes.SET_CLIENT_TYPE;
	payload: {
		clientType: IEditCustomerContext['clientType'];
	};
}

interface IChangeBillTemplateFileData {
	type: EditCustomerActionTypes.CHANGE_BILL_TEMPLATE_FILE_DATA;
	payload: {
		billTemplateFileData: IEditCustomerContext['billTemplateFileData'];
	};
}

interface IChangeBillAdvertisingImageData {
	type: EditCustomerActionTypes.CHANGE_BILL_ADVERTISING_IMAGE_DATA;
	payload: {
		billAdvertisingImageData: IEditCustomerContext['billAdvertisingImageData'];
	};
}

interface IChangeBillAdvertisingLink {
	type: EditCustomerActionTypes.CHANGE_BILL_ADVERTISING_LINK;
	payload: {
		billAdvertisingLink: IEditCustomerContext['billAdvertisingLink'];
	};
}

interface IDeleteBillAdvertisingImage {
	type: EditCustomerActionTypes.DELETE_BILL_ADVERTISING_IMAGE;
}

interface IChangePriceType {
	type: EditCustomerActionTypes.CHANGE_PRICE_TYPE;
	payload: {
		priceType: IEditCustomerContext['priceType'];
	};
}

interface ISetTips0 {
	type: EditCustomerActionTypes.SET_TIPS_0;
	payload: {
		tips0: IEditCustomerContext['tips0'];
	};
}

interface ISetTips1 {
	type: EditCustomerActionTypes.SET_TIPS_1;
	payload: {
		tips1: IEditCustomerContext['tips1'];
	};
}

interface ISetTips2 {
	type: EditCustomerActionTypes.SET_TIPS_2;
	payload: {
		tips2: IEditCustomerContext['tips2'];
	};
}

interface ISetTips3 {
	type: EditCustomerActionTypes.SET_TIPS_3;
	payload: {
		tips3: IEditCustomerContext['tips3'];
	};
}

interface ISetDefaultTips {
	type: EditCustomerActionTypes.SET_DEFAULT_TIPS;
	payload: {
		defaultTips: IEditCustomerContext['defaultTips'];
	};
}

interface IToggleShowLoyaltyProgramButtons {
	type: EditCustomerActionTypes.TOGGLE_SHOW_LOYALTY_PROGRAM_BUTTONS;
}

interface IChangeBaseMcc {
	type: EditCustomerActionTypes.CHANGE_BASE_MCC;
	payload: {
		baseMcc: IEditCustomerContext['baseMcc'];
	};
}

interface IChangeMccCard {
	type: EditCustomerActionTypes.CHANGE_MCC_CARD;
	payload: {
		mccCards: IEditCustomerContext['mccCards'];
	};
}

interface IChangeMainMccCardBrand {
	type: EditCustomerActionTypes.CHANGE_MAIN_MCC_CARD_BRAND;
	payload: {
		mainMccCardBrand: IEditCustomerContext['mainMccCardBrand'];
	};
}

interface IChangeMainMccCardMcc {
	type: EditCustomerActionTypes.CHANGE_MAIN_MCC_CARD_MCC;
	payload: {
		mainMccCardMcc: IEditCustomerContext['mainMccCardMcc'];
	};
}

interface ISetVivaWalletCredentialsId {
	type: EditCustomerActionTypes.SET_VIVA_WALLET_CREDENTIALS_ID;
	payload: {
		vivaWalletCredentialsId: IEditCustomerContext['vivaWalletCredentialsId'];
	};
}

interface ISetAds {
	type: EditCustomerActionTypes.SET_ADS;
	payload: {
		ads: IEditCustomerContext['ads'];
	};
}

interface IChangeMenuVersion {
	type: EditCustomerActionTypes.CHANGE_MENU_VERSION;
	payload: {
		menuVersion: IEditCustomerContext['menuVersion'];
	};
}

interface IChangeContentVersion {
	type: EditCustomerActionTypes.CHANGE_CONTENT_VERSION;
	payload: {
		contentVersion: IEditCustomerContext['contentVersion'];
	};
}

interface ISetMixpanelToken {
	type: EditCustomerActionTypes.SET_MIXPANEL_TOKEN;
	payload: {
		mixpanelToken: IEditCustomerContext['mixpanelToken'];
	};
}

interface ISetStopListSyncIntervalMinutes {
	type: EditCustomerActionTypes.SET_STOP_LIST_SYNC_INTERVAL_MINUTES;
	payload: {
		stopListSyncIntervalMinutes: IEditCustomerContext['stopListSyncIntervalMinutes'];
	};
}

interface ISetFetchedLanguages {
	type: EditCustomerActionTypes.SET_FETCHED_LANGUAGES;
	payload: {
		fetchedLanguages: IEditCustomerContext['fetchedLanguages'];
	};
}

interface ISetIDCustomerDefaultLanguage {
	type: EditCustomerActionTypes.SET_ID_CUSTOMER_DEFAULT_LANGUAGE;
	payload: {
		IDSelectedCustomerDefaultLanguage: IEditCustomerContext['IDSelectedCustomerDefaultLanguage'];
	};
}

interface ISetIDsCustomerLanguages {
	type: EditCustomerActionTypes.SET_IDs_CUSTOMER_LANGUAGES;
	payload: {
		IDsSelectedCustomerLanguages: IEditCustomerContext['IDsSelectedCustomerLanguages'];
		tags: IEditCustomerContext['tags'];
	};
}

interface IChangeTags {
	type: EditCustomerActionTypes.CHANGE_TAGS;
	payload: {
		tags: IEditCustomerContext['tags'];
	};
}

interface IToggleActivateBPA {
	type: EditCustomerActionTypes.TOGGLE_ACTIVATE_BPA;
}

interface ISetDataForSubmit {
	type: EditCustomerActionTypes.SET_DATA_FOR_SUBMIT;
	payload: {
		dataForSubmit: IEditCustomerContext['dataForSubmit'];
	};
}

interface IChangeTypeOfModalWindow {
	type: EditCustomerActionTypes.CHANGE_TYPE_OF_MODAL_WINDOW;
	payload: {
		typeOfModalWindow: IEditCustomerContext['typeOfModalWindow'];
	};
}

interface IResetSelectedControls {
	type: EditCustomerActionTypes.RESET_FIELDS;
}

export type TEditCustomerAction =
	| IRefetchData
	| ISetInitialFormData
	| ISetAllData
	| IChangeVisibleForm
	| ISetFile
	| IDeletePhoto
	| IChangeName
	| IChangeEmail
	| IChangeEmailBodyTemplate
	| ISetClientType
	| IChangeBillTemplateFileData
	| IChangeBillAdvertisingImageData
	| IChangeBillAdvertisingLink
	| IDeleteBillAdvertisingImage
	| IChangePriceType
	| ISetTips0
	| ISetTips1
	| ISetTips2
	| ISetTips3
	| ISetDefaultTips
	| IToggleShowLoyaltyProgramButtons
	| IChangeBaseMcc
	| IChangeMccCard
	| IChangeMainMccCardBrand
	| IChangeMainMccCardMcc
	| ISetVivaWalletCredentialsId
	| ISetAds
	| IChangeMenuVersion
	| IChangeContentVersion
	| ISetMixpanelToken
	| ISetStopListSyncIntervalMinutes
	| ISetFetchedLanguages
	| ISetIDCustomerDefaultLanguage
	| ISetIDsCustomerLanguages
	| IChangeTags
	| IToggleActivateBPA
	| ISetDataForSubmit
	| IChangeTypeOfModalWindow
	| IResetSelectedControls;
